import router from './router'
import store from './store'
import storage from 'good-storage';
import routerUtils from './util/router-utils'


var getRouter;


// function updatePermission() {
router.beforeEach((to, from, next) => {
    // 设置路由meta信息中的title
    let { title, needLogin } = to.meta;
    document.title = title;

    // 判断用户是否登录
    let localToken = storage.session.get("Authorization");
    let storeToken = store.getters.token;
    store.dispatch('sysInfo/updatePath', to.path);
    store.dispatch('common/updateOpcity', to.path)
    if (to.path == '/login') {
        getRouter = undefined;
        next();
    }

    if (process.env.NODE_ENV != "development") {
        // if (!localToken || !storeToken || localToken != storeToken) {
        //     if (to.path == '/login') {
        //         next();
        //     } else {
        //         next('/login')
        //     }
        // }
        if (to.path == '/login') {
                next();
        }else {
            // console.log(getRouter)
            if (!getRouter) {
                if (!routerUtils.getObjArr('router')) {
                    // console.log('beforeEach getRouter');
                    getRouter = store.getters.dynamicRouter;
                    routerUtils.saveObjArr('router', getRouter); //存储路由到sessionStorage
                    routerGo(to, next); //执行路由跳转方法
                } else {
                    // 从sessionStorage拿到了路由
                    getRouter = routerUtils.getObjArr('router'); //拿到路由
                    // console.log(getRouter);
                    routerGo(to, next);
                }
            } else {
                next();
            }
        }
    } else {
        if (to.path == '/login') {
            next();
        } else {
            // console.log("本地开发环境获取路由:" + getRouter);
            if (!getRouter) {
                if (!routerUtils.getObjArr('router')) {
                    // console.log('beforeEach getRouter');
                    getRouter = store.getters.dynamicRouter;
                    routerUtils.saveObjArr('router', getRouter); //存储路由到sessionStorage
                    routerGo(to, next); //执行路由跳转方法
                } else {
                    // 从sessionStorage拿到了路由
                    getRouter = routerUtils.getObjArr('router'); //拿到路由
                    // console.log(getRouter);
                    routerGo(to, next);
                }
            } else {
                next();
            }
        }
    }

});

// }

function routerGo(to, next) {
    getRouter = routerUtils.filterAsyncRouter(getRouter) //过滤路由
    router.addRoutes(getRouter) //动态添加路由
    global.antRouter = getRouter //将路由数据传递给全局变量，做侧边栏菜单渲染工作
    next({
        ...to,
        replace: true
    })
}


// export default {
//   updatePermission
// }



// WEBPACK FOOTER //
// ./src/permission.js